
    const data = {"name":"src/core/icons/file-document-outline","data":{"viewBox":"0 0 24 24","data":"<path pid=\"0\" d=\"M6 2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8l-6-6H6m0 2h7v5h5v11H6V4m2 8v2h8v-2H8m0 4v2h5v-2H8Z\"/>","originalColors":[],"stopColors":[]}}

            export default data
            